<script setup lang="ts">
import { i18n } from '@/i18n';
import { computed } from 'vue';

const t = i18n.t;

const props = withDefaults(
  defineProps<{
    severity: 'warning' | 'critical';
    direction: 'shortage' | 'excess';
    momChangeRateThreshold: string;
    minQuantityThreshold: string;
    withDefaultDesc?: boolean;
    defaultValueString?: string;
  }>(),
  { defaultValueString: undefined }
);
const emits = defineEmits(['update:momChangeRateThreshold', 'update:minQuantityThreshold']);

const title = computed(
  () => props.severity + (props.direction === 'excess' ? '_excess_forecast_sharp_decrease' : '_shortage_forecast_sharp_increase')
);
const text = computed(() => (props.direction === 'excess' ? 'dashboard:以下' : 'dashboard:以上'));
</script>
<template>
  <div class="alert-input-sharp">
    <div class="label">{{ t(title) }}</div>
    <div>
      {{ t('前月比') }}
      <input
        :value="props.momChangeRateThreshold"
        type="number"
        min="0"
        max="999"
        class="alert-input-sharp__input alert-input-sharp__input--percentage"
        @input="emits('update:momChangeRateThreshold', $event)"
        @keydown.e.prevent
      />
      % {{ t(text) }}
    </div>
    <div>
      {{ t('数量') }}
      <input
        :value="props.minQuantityThreshold"
        type="number"
        min="0"
        :max="Number.MAX_SAFE_INTEGER"
        class="alert-input-sharp__input alert-input-sharp__input--quantity"
        @input="emits('update:minQuantityThreshold', $event)"
        @keydown.e.prevent
      />
      {{ t('以上') }}
    </div>
    <div v-if="defaultValueString" class="default-value">
      {{ t(defaultValueString) }}
    </div>
  </div>
</template>
<style lang="scss" scoped>
.alert-input-sharp {
  display: grid;
  grid-template-rows: max-content;
  gap: 8px;
  padding: 8px;
  *:not(.material-icons) {
    font-family: Noto Sans JP;
  }

  .label {
    font-weight: 700;
  }

  &__input {
    padding: 8px;
    border-radius: 4px;
    border: 1px solid $borderDefault;
    line-height: 1;
    &--percentage {
      width: 80px;
    }
    &--quantity {
      width: 94px;
    }
  }
}
.default-value {
  font-size: 13px;
  color: $textSecondary;
}
</style>
